import styled, { css } from 'styled-components';
import { Select } from 'antd';

interface IErrors {
    error?: string;
}

export const StyledSelect = styled(Select)<IErrors>`
    && {
        width: 100%;
        ${({ theme, error }) => css`
            .ant-select-selector {
                height: 3.5rem;
                border-radius: 0.8rem;
                align-items: center;

                font-size: ${theme.fontSizes.default};
                color: ${theme.colors.font};

                &:hover,
                &:focus {
                    ${!error &&
                    css`
                        border-color: ${theme.colors.accentColor};
                    `};
                }

                ${error &&
                css`
                    border-color: ${theme.colors.fail};
                `};
            }
        `};
    }
`;

export const Title = styled.p`
    ${({ theme }) => css`
        color: ${theme.colors.font};
        font-size: ${theme.fontSizes.little};
        margin-bottom: 0.5rem;
    `}
`;
